import React, { useState } from 'react';
import { ALL_CONSTANT, EntityTypes, Status } from '@guryou/core';
import { Spinner } from '@guryou/html-components';
import { stateIsLoaded } from '@guryou/redux';
import Slider from 'components/slider';
import AllReservationsTable from './AllReservationsTable';
import BreadCrumb from './breadcrumb';
import ServiceCards from './ServiceCards';

const Reservations = ({ myOrders }) => {
  const [view, setView] = useState(ALL_CONSTANT);
  const [status, setStatus] = useState(Status.upcoming);
  const [sliderView, setSliderView] = useState(false);
  const { data } = myOrders;

  if (!stateIsLoaded(myOrders)) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spinner />
      </div>
    );
  }

  const checkView = type => view === ALL_CONSTANT || view === type;

  const cards = (
    <div className="space-y-8">
      {checkView(EntityTypes.service) && (
        <ServiceCards view={EntityTypes.service} data={data.filter(x => x.type === EntityTypes.service)} status={status} isNotVideo={true} />
      )}
      {checkView(EntityTypes.course) && (
        <ServiceCards view={EntityTypes.course} data={data.filter(x => x.type === EntityTypes.course)} status={status} isNotVideo={true} />
      )}
      {checkView(EntityTypes.event) && (
        <ServiceCards view={EntityTypes.event} data={data.filter(x => x.type === EntityTypes.event)} status={status} isNotVideo={true} />
      )}
      {checkView(EntityTypes.video) && (
        <ServiceCards view={EntityTypes.video} data={data.filter(x => x.type === EntityTypes.video)} status={status} />
      )}
    </div>
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-4 border-b border-gray-200">
        <BreadCrumb onChangeService={setView} onChangeStatus={setStatus} />
        <Slider sliderStartingView={sliderView} onChange={setSliderView} />
      </div>

      <div className="bg-white rounded-lg shadow-sm p-6">
        {sliderView ? cards : <AllReservationsTable view={view} status={status} obj={myOrders} />}
      </div>
    </div>
  );
};

export default Reservations;
